import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadSapRequestDTO extends PerformedByRequestDTO {
    userEmailOrName?: string;
}
